import { Button, Flex, Modal, Text } from '@mantine/core';
import { FC, useLayoutEffect, useState } from 'react';
import { useDisclosure } from '@mantine/hooks';
import { useTypedDispatch } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import { SavedCreatorState } from '@/types/creator';
import { presetId } from '@/components/App';
import APP_CONFIG from '@/configs/appConfig';

export const RestoreProjectModal: FC = () => {
	const dispatch = useTypedDispatch();

	const [isOpen, modalControls] = useDisclosure();

	const [payload, setPayload] = useState<SavedCreatorState | null>(null);

	useLayoutEffect(() => {
		if (import.meta.env.DEV) return;
		if (presetId) return;

		const tempPrpoject = localStorage.getItem(
			APP_CONFIG.TEMP_PROJECT_STORAGE_KEY
		);

		if (!tempPrpoject) return;
		modalControls.open();

		try {
			const payload = JSON.parse(tempPrpoject);
			setPayload(payload);
		} catch (error) {
			console.error('INVALID_PAYLOAD', error);
		}
	}, []);

	const handleClose = () => {
		modalControls.close();
		localStorage.removeItem(APP_CONFIG.TEMP_PROJECT_STORAGE_KEY);
	};

	const handleRestore = () => {
		if (!payload) return;

		dispatch(creatorActions.loadProject(payload));
		setPayload(null);
		handleClose();
	};

	return (
		<Modal
			opened={isOpen}
			onClose={handleClose}
			title="Niezapisany projekt"
			size="sm"
		>
			<Text mb="md" c="dimmed">
				Wykryliśmy niezapisany projekt. Czy chcesz do niego wrócić?
			</Text>
			<Flex gap="md">
				<Button fullWidth color="black" onClick={handleClose}>
					Zacznij od nowa
				</Button>
				<Button fullWidth onClick={handleRestore} color="cream.6">
					Przywróć
				</Button>
			</Flex>
		</Modal>
	);
};
